import { IAgentFromAPI, APICall, ICourse } from '../../types';
import { UploadFileStatus } from '../../types/index.d';

export enum DataActionTypes {
  GET_AGENTS = '@@data/GET_AGENTS',
  GET_AGENTS_SUCCESS = '@@data/GET_AGENTS_SUCCESS',
  GET_AGENTS_FAILURE = '@@data/GET_AGENTS_FAILURE',
  RETRY_API_CALL = '@@student/RETRY_API_CALL',
  RETRY_API_CALL_SUCCESS = '@@student/RETRY_API_CALL_SUCCESS',
  RETRY_API_CALL_FAILED = '@@student/RETRY_API_CALL_FAILED',
  GET_COURSE_SUGGESTIONS = '@@visa/personalInfo/GET_COURSE_SUGGESTIONS',
  GET_COURSE_SUGGESTIONS_SUCCESS = '@@visa/personalInfo/GET_COURSE_SUGGESTIONS_SUCCESS',
  GET_COURSE_SUGGESTIONS_FAILURE = '@@visa/personalInfo/GET_COURSE_SUGGESTIONS_FAILURE',
  GET_UPLOAD_FILE_URL = '@@visa/GET_UPLOAD_FILE_URL',
  GET_UPLOAD_FILE_URL_SUCCESS = '@@visa/GET_UPLOAD_FILE_URL_SUCCESS',
  GET_UPLOAD_FILE_URL_FAILURE = '@@visa/GET_UPLOAD_FILE_URL_FAILURE',
  UPLOAD_FILE = '@@visa/UPLOAD_FILE',
  UPLOAD_FILE_SUCCESS = '@@visa/UPLOAD_FILE_SUCCESS',
  UPLOAD_FILE_FAILURE = '@@visa/UPLOAD_FILE_FAILURE'
}

export interface IUploadFile {
  name?: string;
  status: UploadFileStatus;
  index?: number;
  isFileUploading: boolean;
}
export interface IDataState {
  readonly isConfigLoading: boolean;
  readonly isConfigLoaded: boolean;
  readonly isStudentLoaded: boolean;
  readonly agentSuggestions: Array<IAgentFromAPI>;
  readonly apiCallsInProgress: APICall[];
  readonly courseSuggestions: Array<ICourse>;
  readonly uploadFile: IUploadFile | null;
  readonly uploadError: string | null;
}
